import { render } from "./SimpleSegment.vue?vue&type=template&id=49e67183&scoped=true&ts=true"
import script from "./SimpleSegment.vue?vue&type=script&lang=ts"
export * from "./SimpleSegment.vue?vue&type=script&lang=ts"

import "./SimpleSegment.vue?vue&type=style&index=0&id=49e67183&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e67183"]])

export default __exports__